// Generated by purs version 0.13.0
"use strict";
var Data_Array = require("../Data.Array/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Unfoldable = require("../Data.Unfoldable/index.js");
var Ritoppu_Action = require("../Ritoppu.Action/index.js");
var Ritoppu_Action_CreatureAct = require("../Ritoppu.Action.CreatureAct/index.js");
var Ritoppu_Model_Creature = require("../Ritoppu.Model.Creature/index.js");
var Ritoppu_Model_FovMask = require("../Ritoppu.Model.FovMask/index.js");
var Ritoppu_Model_Item = require("../Ritoppu.Model.Item/index.js");
var Ritoppu_Model_Point = require("../Ritoppu.Model.Point/index.js");
var Ritoppu_Model_Stage = require("../Ritoppu.Model.Stage/index.js");
var Ritoppu_Mutation_Game = require("../Ritoppu.Mutation.Game/index.js");
var Ritoppu_Mutation_Inventory = require("../Ritoppu.Mutation.Inventory/index.js");
var Ritoppu_Mutation_Player = require("../Ritoppu.Mutation.Player/index.js");
var Ritoppu_Mutation_Stage = require("../Ritoppu.Mutation.Stage/index.js");
var Ritoppu_Mutation_Stats = require("../Ritoppu.Mutation.Stats/index.js");
var removeItem = function (item) {
    return function (game) {
        return {
            stage: {
                player: {
                    pos: game.stage.player.pos,
                    stats: game.stage.player.stats,
                    turn: game.stage.player.turn,
                    inventory: Ritoppu_Mutation_Inventory.removeItemFromInventory(item)(game.stage.player.inventory),
                    level: game.stage.player.level,
                    equipment: game.stage.player.equipment
                },
                tiles: game.stage.tiles,
                size: game.stage.size,
                seen: game.stage.seen,
                items: game.stage.items,
                fovMask: game.stage.fovMask,
                creatures: game.stage.creatures
            },
            dungeonLevel: game.dungeonLevel
        };
    };
};
var playerTurn = function (game) {
    return {
        stage: {
            player: {
                pos: game.stage.player.pos,
                stats: game.stage.player.stats,
                turn: game.stage.player.turn + 5 | 0,
                inventory: game.stage.player.inventory,
                level: game.stage.player.level,
                equipment: game.stage.player.equipment
            },
            tiles: game.stage.tiles,
            size: game.stage.size,
            seen: game.stage.seen,
            items: game.stage.items,
            fovMask: game.stage.fovMask,
            creatures: game.stage.creatures
        },
        dungeonLevel: game.dungeonLevel
    };
};
var castConfusion = function (dest) {
    return function (game) {
        var v = Ritoppu_Model_Stage.creatureAt(game.stage)(dest);
        if (v instanceof Data_Maybe.Just && Ritoppu_Model_FovMask.isVisibleTile(game.stage.fovMask)(dest)) {
            return Ritoppu_Action.addAction(new Ritoppu_Action.LogMessage(new Ritoppu_Action.CastConfusion(v.value0)))(Ritoppu_Action_CreatureAct.creatureAct(playerTurn({
                stage: Ritoppu_Mutation_Stage.updateCreature(dest)(function (c) {
                    return {
                        type: c.type,
                        stats: c.stats,
                        turn: c.turn,
                        aiStrategy: new Ritoppu_Model_Creature.ConfusedAI(10, v.value0.aiStrategy),
                        xp: c.xp
                    };
                })(game.stage),
                dungeonLevel: game.dungeonLevel
            })));
        };
        if (v instanceof Data_Maybe.Just) {
            return Ritoppu_Action.withAction(game)(new Ritoppu_Action.LogMessage(Ritoppu_Action.TargetingOutOfFov.value));
        };
        if (v instanceof Data_Maybe.Nothing) {
            return Ritoppu_Action.withAction(game)(new Ritoppu_Action.LogMessage(Ritoppu_Action.TargetNoEnemy.value));
        };
        throw new Error("Failed pattern match at Ritoppu.Action.CastTargeting (line 77, column 27 - line 85, column 56): " + [ v.constructor.name ]);
    };
};
var addExperience = function (xp) {
    return function (stage) {
        return {
            player: Ritoppu_Mutation_Player.gainXp(xp)(stage.player),
            tiles: stage.tiles,
            size: stage.size,
            seen: stage.seen,
            items: stage.items,
            fovMask: stage.fovMask,
            creatures: stage.creatures
        };
    };
};
var castFireball = function (dest) {
    return function (game) {
        var hitsPlayer = Ritoppu_Model_Point.doubleDistanceBetween(dest)(game.stage.player.pos) <= (3 * 3 | 0);
        var creatures = Data_Array.filter(function (v) {
            return Ritoppu_Model_Point.doubleDistanceBetween(v.value0)(dest) <= (3 * 3 | 0);
        })(Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray)(game.stage.creatures));
        var logs = Data_Semigroup.append(Data_Semigroup.semigroupArray)([ new Ritoppu_Action.FireballExplodes(3) ])(Data_Semigroup.append(Data_Semigroup.semigroupArray)(Data_Functor.map(Data_Functor.functorArray)(function (v) {
            return new Ritoppu_Action.BurnM(v.value1, 25);
        })(creatures))((function () {
            if (hitsPlayer) {
                return [ new Ritoppu_Action.BurnSelf(25) ];
            };
            return [  ];
        })()));
        var attackedStage = function (g) {
            return removeItem(Ritoppu_Model_Item.FireballScroll.value)({
                stage: Data_Foldable.foldr(Data_Foldable.foldableArray)(function (v1) {
                    var $23 = v1.value1.stats.hp <= 25;
                    if ($23) {
                        var $28 = addExperience(v1.value1.xp);
                        var $29 = Ritoppu_Mutation_Stage.addItem(v1.value0)(Ritoppu_Model_Item.newCorpse(v1.value1));
                        var $30 = Ritoppu_Mutation_Stage.removeCreature(v1.value0);
                        return function ($31) {
                            return $28($29($30($31)));
                        };
                    };
                    return Ritoppu_Mutation_Stage.updateCreature(v1.value0)(function (c) {
                        return {
                            type: c.type,
                            stats: Ritoppu_Mutation_Stats.takeDamage(25)(c.stats),
                            turn: c.turn,
                            aiStrategy: c.aiStrategy,
                            xp: c.xp
                        };
                    });
                })(g.stage)(creatures),
                dungeonLevel: g.dungeonLevel
            });
        };
        var attackPlayer = function (g) {
            if (hitsPlayer) {
                return Ritoppu_Mutation_Game.hitPlayer(25)(g);
            };
            if (!hitsPlayer) {
                return g;
            };
            throw new Error("Failed pattern match at Ritoppu.Action.CastTargeting (line 40, column 20 - line 42, column 15): " + [ hitsPlayer.constructor.name ]);
        };
        var v = Ritoppu_Model_FovMask.isVisibleTile(game.stage.fovMask)(dest);
        if (!v) {
            return Ritoppu_Action.withAction(game)(new Ritoppu_Action.LogMessage(Ritoppu_Action.TargetingOutOfFov.value));
        };
        if (v) {
            return Ritoppu_Action.addActions(Data_Functor.map(Data_Functor.functorArray)(Ritoppu_Action.LogMessage.create)(logs))(Ritoppu_Action_CreatureAct.creatureAct(playerTurn(attackedStage(attackPlayer(game)))));
        };
        throw new Error("Failed pattern match at Ritoppu.Action.CastTargeting (line 18, column 26 - line 23, column 69): " + [ v.constructor.name ]);
    };
};
module.exports = {
    castFireball: castFireball,
    castConfusion: castConfusion
};
